import React from "react";
import { useHistory } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import WebLayout from "../components/WebLayout";
import PostTable from "../components/PostTable";
import { useAlert } from "./../components/Alert";

const GET_ENROLLMENT_ARTICLES = gql`
  query GetEnrollmentArticles {
    articles(category: ENROLLMENT) {
      id
      title
      source
      picture {
        filename
        mimetype
        encoding
        location
      }
      description
      content
      createdAt
    }
  }
`;

const REMOVE_ENROLLMENT_ARTICLE = gql`
  mutation RemoveEnrollmentArticle($id: ID!) {
    removeArticle(id: $id) {
      success
      message
    }
  }
`;

export default function ConsoleEnrollmentListPage() {
  const Alert = useAlert();
  const history = useHistory();
  const { data, refetch } = useQuery(GET_ENROLLMENT_ARTICLES, {
    fetchPolicy: "no-cache",
  });
  const [removeArticle] = useMutation(REMOVE_ENROLLMENT_ARTICLE, {
    fetchPolicy: "no-cache",
    onCompleted({ removeArticle }) {
      if (removeArticle.success) {
        refetch();
      } else {
        Alert.alert("", `${removeArticle.message}`, [
          {
            text: "確定",
            type: "ok",
          },
        ]);
      }
    },
    onError(error) {
      Alert.alert("", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  return (
    <WebLayout
      title={"研習辦理報名"}
      onAdd={() => history.push(`/console/enrollment/add`)}
    >
      <PostTable
        hypnotist={data && data.articles}
        onEdit={(index) => {
          let has = data.articles.find(
            (articlesItem) => articlesItem.id === index
          );
          if (has.picture) {
            delete has.picture.__typename;
          }
          history.push(`/console/enrollment/${has.id}`, { data: has });
        }}
        onDelete={(index) => {
          let has = data.articles.find(
            (articlesItem) => articlesItem.id === index
          );
          Alert.alert("", "確定要刪除？", [
            {
              text: "確定",
              onClick: () => {
                removeArticle({ variables: { id: has.id } });
              },
              type: "ok",
            },
            {
              text: "取消",
            },
          ]);
        }}
      />
    </WebLayout>
  );
}
